import * as React from 'react';

export default function CookieBotScript({ cookieBotId }: { cookieBotId: string }) {
  return (
    // eslint-disable-next-line @next/next/no-sync-scripts -- CookieBot needs to be loaded synchronously, see https://support.cookiebot.com/hc/en-us/articles/360009074960-Automatic-cookie-blocking
    <script
      id="CookieBot"
      src="https://consent.cookiebot.com/uc.js"
      data-cbid={cookieBotId}
      data-blockingmode="auto"
      type="text/javascript"
    />
  );
}
